import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import parse from 'html-react-parser';

function AgentMisReport() {
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [repDate, setRepDate] = useState(new Date());
    const [repMode, setRepMode] = useState("D");
    const [repAgent, setRepAgent] = useState("0");
    const [repAgentList, setRepAgentList] = useState([]);

    const [repBranch, setRepBranch] = useState("0");
    const [repBranchList, setRepBranchList] = useState([]);

    const [repOutput, setRepOutput] = useState("");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'REPAGENTBUSINESS'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    Common.callApi(Common.apiUser, [sid, 'branchallowedall'], function (result) {
                        let resp1 = JSON.parse(result);
                        setRepBranchList(resp1);
                        if (resp1.length === 2) {
                            setRepBranch(resp1[1].value);
                        }
                    });
                    Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentselect'], function (result) {
                        setRepAgentList(JSON.parse(result));
                    });
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    function genReport() {
        var object1 = {
            right: 'REPAGENTBUSINESS',
            mode: repMode,
            date: Common.dateYMD(repDate),
            agent: repAgent,
            branch: repBranch
        }
        console.log(object1);
        if (repAgent === "0") {
            alert("Please select agent.");
        } else {
            if (repMode === "D") {
                Common.callDownloadApiPost(Common.apiReport, "post", [sid, JSON.stringify(object1)]);
            } else if (repMode === "V") {
                Common.callApi(Common.apiReport, [sid, JSON.stringify(object1)], function (result) {
                    setRepOutput(result);
                });
            }
        }
    }

    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>Agent Business Report</h1>
                    </Col>
                </Row>
                <Row>
                    <Col className='col-md-4 col-6'>
                        <Form.Group>
                            <Form.Label>Mode </Form.Label>
                            <Form.Select
                                value={repMode}
                                onChange={(e) => setRepMode(e.target.value)} >
                                <option value="D">Download</option>
                                <option value="V">View</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-4 col-6'>
                        <Form.Group>
                            <Form.Label>Agent</Form.Label>
                            <Form.Select value={repAgent} onChange={(e) => setRepAgent(e.target.value)} >
                                <option value="0">Select</option>
                                {repAgentList.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-4 col-6'>
                        <Form.Group>
                            <Form.Label>Branch</Form.Label>
                            <Form.Select value={repBranch} onChange={(e) => setRepBranch(e.target.value)} >
                                {repBranchList.map(res => <option key={res.value} value={res.value}>{res.name}</option>)}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col className='col-md-4 col-6'>
                        <Form.Group>
                            <Form.Label>Date</Form.Label>
                            <DatePicker className="form-control"
                                selected={repDate}
                                onChange={(date) => setRepDate(date)}
                                isClearable
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button variant="outline-primary" size="sm" onClick={() => genReport()}>Generate</Button>&nbsp;
                    </Col>
                </Row>
                <Row>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {parse(repOutput)}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default AgentMisReport
